import {Buyers, OrderItemAttribute, SubstitutionMode} from './itemDetails';

import {Flags} from '@buncha/batchDetails/types';
import {ShopperItemChangesForShopper} from './ItemScanner';

/* eslint-disable no-shadow */
export enum ItemReplacementCellMode {
  proactive = 'proactive',
  nonProactive = 'nonProactive',
}
export enum SubstitutionChoice {
  byShopper = 'byShopper',
  byBuyer = 'byBuyer',
  noSubstitution = 'noSubstitution',
  none = 'none',
  anyBrand = 'anyBrand',
  meijerBrand = 'meijerBrand',
  nationalBrand = 'nationalBrand',
}

export interface SubstitutionOptions {
  id: number;
  name: string;
  itemImageUrl: string;
  price: number;
  catalogItemId: number;
  isCustomItem: boolean;
  upc: string;
  orderItem: {
    orderId: number;
    position: number;
    substitutedBy: string;
  };
  metaLoggingForKpi?: JSON;
}

export interface ReplacementItemDetails {
  id: number;
  itemLocation: string;
  itemImageUrl: string;
  name: string;
  quantity: number;
  substitutionNote: string;
  catalogItemId: number;
  tags: string;
  price: number;
  substitutionChoice: SubstitutionChoice;
  substitutionOptions: SubstitutionOptions[];
  shopperItemChangesForShopper: ShopperItemChangesForShopper;
  order: {
    id: number;
    buyer: Buyers;
    run: {
      id: number;
      store: {
        id: number;
        elasticSearchIndex: string;
      };
    };
  };
  isNSC2Item: boolean;
  orderItemAttribute: OrderItemAttribute;
}
export interface RecommendedItemCell {
  id: number;
  itemImageUrl: string;
  name: string;
  quantity: number;
  price: number;
  itemSource: string;
  indexPosition: number;
  tags: string[];
  flags: Flags;
  metaLoggingForKpi?: JSON;
  upc: string;
  itemType: ItemType;
}
export interface State {
  item: ReplacementItemDetails | undefined;
  searchResults: SearchResults[];
  showCustomItemCTA: boolean;
  hasSearching: boolean;
}

export interface SubstitutionRequestParams {
  catalogItemId: number;
  orderItemId: number;
  quantity: number;
  itemSource: string;
  indexPosition: number;
}

export interface RecommendationsForSubParams {
  catalogItemId: number;
  searchQuery: string;
  category: string;
  storeId: number;
  subCategory: string;
}

export interface SubstitutionItemParams {
  catalogItemId?: number;
  isCustomItem: boolean;
  itemImageUrl?: string;
  name: string;
  orderId: number;
  orderItemId: number;
  position?: number;
  price: number;
  quantity: number;
  substitutedBy: string;
  substitutionItemId?: number;
  substitutionRequestParmas?: ItemSubstitutionRequestParamas;
  itemSource?: string;
  indexPosition?: number;
  isPriceSensitive?: boolean;
  isWeightSensitive?: boolean;
  metaLoggingForKpi?: JSON;
  runId?: number;
  upcInput?: {
    upcCodes?: string[];
    upcOriginal?: string;
  };
}

export interface ItemSubstitutionRequestParamas {
  id?: number;
  substitutionMode: SubstitutionMode;
}

export enum SearchType {
  substitutionSearch = 'substitutionSearch',
  userSearch = 'userSearch',
}

export interface SearchItemsForSubParams {
  storeId: number;
  searchQuery: string;
  from: number;
  size: number;
  catalogItemId?: number;
  runId?: number;
  searchType?: SearchType;
}

export interface SearchItemsForSubParamsUPC {
  esIndex: string;
  searchQuery: string;
  from: number;
  size: number;
  catalogItemId: number;
  runId?: number;
}

export enum ItemType {
  Alcoholic = 'Alcoholic',
  Non_Alcoholic = 'Non_Alcoholic',
}

export interface SearchResults {
  id: number;
  name: string;
  price: number;
  tags: string[];
  description: string;
  itemImageUrl: string;
  itemType: ItemType;
  itemSource: string;
  indexPosition: number;
  itemQuantity?: string;
  flags: Flags;
  metaLoggingForKpi?: JSON;
  upc: string;
}

export interface SearchCatalog {
  totalResult: number;
  items: SearchResults[];
  searchRelevance: SearchRelevance[];
}

export interface SearchRelevance {
  key: string;
  length: number;
  name: string;
}
